import React from "react";


export function IconInputText(){
    return (
        <div className="flex flex-col items-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 inline-block mt-1">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
            </svg>
        </div>
    );
}

export function IconInputSVG(){
    return (
        <div className="flex flex-col items-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
                 stroke="currentColor" className="w-10 h-10 inline-block mt-1">
                <path strokeLinecap="round" strokeLinejoin="round"
                      d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"/>
            </svg>
        </div>
    );
}

export function IconInputShape(){
    return (
        <div className="flex flex-col items-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-10 h-10 inline-block mt-1">
                <path d="M12.378 1.602a.75.75 0 0 0-.756 0L3 6.632l9 5.25 9-5.25-8.622-5.03ZM21.75 7.93l-9 5.25v9l8.628-5.032a.75.75 0 0 0 .372-.648V7.93ZM11.25 22.18v-9l-9-5.25v8.57a.75.75 0 0 0 .372.648l8.628 5.033Z" />
            </svg>
        </div>
    );
}

export function IconThikness({props}){
    return (
        <div className="flex flex-col items-center"
             {...props}
        >

            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-10 h-10 inline-block">
                <path fillRule="evenodd" d="M6.97 2.47a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06L8.25 4.81V16.5a.75.75 0 0 1-1.5 0V4.81L3.53 8.03a.75.75 0 0 1-1.06-1.06l4.5-4.5Zm9.53 4.28a.75.75 0 0 1 .75.75v11.69l3.22-3.22a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.22 3.22V7.5a.75.75 0 0 1 .75-.75Z" clipRule="evenodd" />
            </svg>

        </div>
    );
}
export function IconCursor(){
    return (
        <div className="flex flex-col items-center">
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-10 h-10 inline-block mt-1">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.29227 0.048984C3.47033 -0.032338 3.67946 -0.00228214 3.8274 0.125891L12.8587 7.95026C13.0134 8.08432 13.0708 8.29916 13.0035 8.49251C12.9362 8.68586 12.7578 8.81866 12.5533 8.82768L9.21887 8.97474L11.1504 13.2187C11.2648 13.47 11.1538 13.7664 10.9026 13.8808L8.75024 14.8613C8.499 14.9758 8.20255 14.8649 8.08802 14.6137L6.15339 10.3703L3.86279 12.7855C3.72196 12.934 3.50487 12.9817 3.31479 12.9059C3.1247 12.8301 3 12.6461 3 12.4414V0.503792C3 0.308048 3.11422 0.130306 3.29227 0.048984ZM4 1.59852V11.1877L5.93799 9.14425C6.05238 9.02363 6.21924 8.96776 6.38319 8.99516C6.54715 9.02256 6.68677 9.12965 6.75573 9.2809L8.79056 13.7441L10.0332 13.178L8.00195 8.71497C7.93313 8.56376 7.94391 8.38824 8.03072 8.24659C8.11753 8.10494 8.26903 8.01566 8.435 8.00834L11.2549 7.88397L4 1.59852Z"
                    fill="currentColor"
                />
            </svg>


        </div>
    );
}
export function IconTrash({className}){
    return (
        <div className="flex flex-col items-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className ? className : "w-7 h-7 inline-block"}>
                <path strokeLinecap="round" strokeLinejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z" />
            </svg>
        </div>
    );
}

export function IconPlus({className}) {
    return (
        <div className="flex flex-col items-center ">

            <svg
                xmlns="http://www.w3.org/2000/svg" fill="black" stroke="white" viewBox="0 0 24 24" className={className ? className : "w-10 h-10 inline-block mt-1"}>
                <path strokeLinecap="round" fill="yellow" strokeLinejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>

        </div>
    )
}

export function IconMove(){
    return (
        <div className="flex flex-col items-center">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="w-10 h-10 inline-block mt-1">
                <path
                    d="m21.71 11.31-3-3a1 1 0 0 0 -1.42 1.42l1.29 1.27h-5.58v-5.59l1.29 1.3a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.42l-3-3a1 1 0 0 0 -.71-.29 1 1 0 0 0 -.7.29l-3 3a1 1 0 0 0 1.41 1.42l1.29-1.29v5.58h-5.59l1.3-1.29a1 1 0 0 0 -1.42-1.42l-3 3a1 1 0 0 0 -.29.71 1 1 0 0 0 .29.71l3 3a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29 1 1 0 0 0 0-1.42l-1.29-1.29h5.58v5.59l-1.29-1.3a1 1 0 0 0 -1.42 1.42l3 3a1 1 0 0 0 .71.29 1 1 0 0 0 .7-.29l3-3a1 1 0 0 0 -1.42-1.42l-1.28 1.29v-5.58h5.59l-1.3 1.29a1 1 0 0 0 0 1.42 1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29l3-3a1 1 0 0 0 .29-.71 1 1 0 0 0 -.29-.69z"
                    fill="#ffffff"/>
            </svg>
        </div>
    );
}



export function IconCopy(props){
    return (
        <div className="flex flex-col items-center" {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-7 h-7 inline-block">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75" />
            </svg>
        </div>
    );
}

export function IconCopy2({props}){
    return (
        <div className="flex flex-col items-center" {...props}>
            <svg fill="none" stroke="currentColor" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" >
                <g strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
                    <path
                        d="m16 12.9v4.2c0 3.5-1.4 4.9-4.9 4.9h-4.2c-3.5 0-4.9-1.4-4.9-4.9v-4.2c0-3.5 1.4-4.9 4.9-4.9h4.2c3.5 0 4.9 1.4 4.9 4.9z"/>
                    <path
                        d="m22 6.9v4.2c0 3.5-1.4 4.9-4.9 4.9h-1.1v-3.1c0-3.5-1.4-4.9-4.9-4.9h-3.1v-1.1c0-3.5 1.4-4.9 4.9-4.9h4.2c3.5 0 4.9 1.4 4.9 4.9z"/>
                </g>
            </svg>
        </div>
    );
}

export function IconUpload({className}){
    return (
        <div className="flex flex-col items-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className ? className : "w-10 h-10 inline-block mt-1"}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5" />
            </svg>

        </div>
    );
}
export function IconPaste(){
    return (
        <div className="flex flex-col items-center">
            <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" className="w-10 h-10 inline-block mt-1">
                <path d="m0 0h24v24h-24z" fill="#fff" opacity="0"/>
                <path
                    d="m18 9h-3v-3.33a2.68 2.68 0 0 0 -2.67-2.67h-6.66a2.68 2.68 0 0 0 -2.67 2.67v6.66a2.68 2.68 0 0 0 2.67 2.67h3.33v3a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3v-6a3 3 0 0 0 -3-3zm-9 3v1h-3.33a.67.67 0 0 1 -.67-.67v-6.66a.67.67 0 0 1 .67-.67h6.66a.67.67 0 0 1 .67.67v3.33h-1a3 3 0 0 0 -3 3z"
                    fill="#ffffff"/>
            </svg>
        </div>
    );
}

export function IconUndo(){
    return (
        <div className="flex flex-col items-center fill-neutral" >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-10 h-10 inline-block">
                <path fillRule="evenodd" d="M15 3.75A5.25 5.25 0 0 0 9.75 9v10.19l4.72-4.72a.75.75 0 1 1 1.06 1.06l-6 6a.75.75 0 0 1-1.06 0l-6-6a.75.75 0 1 1 1.06-1.06l4.72 4.72V9a6.75 6.75 0 0 1 13.5 0v3a.75.75 0 0 1-1.5 0V9c0-2.9-2.35-5.25-5.25-5.25Z" clipRule="evenodd" />
            </svg>
        </div>
    );
}
export function IconRectangle(){
    return (
        <div className="flex flex-col items-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="" viewBox="0 0 24 24" strokeWidth={1.5} stroke="" className="w-10 h-10 inline-block ">
                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 7.125C2.25 6.504 2.754 6 3.375 6h6c.621 0 1.125.504 1.125 1.125v3.75c0 .621-.504 1.125-1.125 1.125h-6a1.125 1.125 0 0 1-1.125-1.125v-3.75ZM14.25 8.625c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v8.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-8.25ZM3.75 16.125c0-.621.504-1.125 1.125-1.125h5.25c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-2.25Z" />
            </svg>

        </div>
    );
}
export function IconCircle(){
    return (
        <div className="flex flex-col items-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 inline-block mt-1">
                <path strokeLinecap="round" strokeLinejoin="round" d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />
            </svg>
        </div>
    );
}

export function IconTriangle(){
    return (
        <div className="flex flex-col items-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-10 h-10 inline-block mt-1">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
            </svg>

        </div>
    );
}

export function IconRedo({props, className}){
    return (
        <div className={`flex flex-col items-center`}>
            <svg
                className={`w-10 h-10 inline-block  `}
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke=""
                version="1.1"
                id="svg192"
                xmlns="http://www.w3.org/2000/svg"

            >
                <path
                    className={`${className}`}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="m 9,15 6,6 m 0,0 6,-6 m -6,6 V 9 A 6,6 0 0 0 3,9 v 3"
                    id="path190" />
            </svg>

        </div>
    );
}

export const IconBaseLayout = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className="w-10 h-10 inline-block" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16M4 18h16" />
        </svg>
    );
};
export const IconSave = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-7 h-7 inline-block">
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 16.5V9.75m0 0 3 3m-3-3-3 3M6.75 19.5a4.5 4.5 0 0 1-1.41-8.775 5.25 5.25 0 0 1 10.338-2.32 3.75 3.75 0 0 1 4.034 4.308A4.522 4.522 0 0 1 18 19.5H6.75Z" />
        </svg>
    );
};

// Un rectángulo con la esquina superior izquierda redondeada, y el radio de esa
// esquina punteado: es lo que ajusta el panel de esquinas redondeadas.
export const IconCornerRadius = (props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M4 20V11a7 7 0 0 1 7-7h9"
            />
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="2 2"
                d="M4 11h7V4"
            />
        </svg>
    )
}

export const IconAddSVG = (props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
        </svg>
    )
}

export const IconAddText = (props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.8}
            stroke="currentColor"
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M6.5 5h11M12 5v14M9 19h6" />
        </svg>
    )
}
export const IconHole = (props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
        </svg>
    );
};


export const IconColor = (props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"

        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M4.098 19.902a3.75 3.75 0 0 0 5.304 0l6.401-6.402M6.75 21A3.75 3.75 0 0 1 3 17.25V4.125C3 3.504 3.504 3 4.125 3h5.25c.621 0 1.125.504 1.125 1.125v4.072M6.75 21a3.75 3.75 0 0 0 3.75-3.75V8.197M6.75 21h13.125c.621 0 1.125-.504 1.125-1.125v-5.25c0-.621-.504-1.125-1.125-1.125h-4.072M10.5 8.197l2.88-2.88c.438-.439 1.15-.439 1.59 0l3.712 3.713c.44.44.44 1.152 0 1.59l-2.879 2.88M6.75 17.25h.008v.008H6.75v-.008Z" />
        </svg>

    )
}

export const IconCircleLayout = (props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            width="99.234"
            height="99.234"
            version="1.1"
            viewBox="0 0 26.256 26.256"
        >
            <path
                style={{ InkscapeStroke: "none" }}
                fill="#000"
                d="M13.127 0C5.883 0 0 5.883 0 13.127c0 7.244 5.883 13.129 13.127 13.129 7.244 0 13.129-5.885 13.129-13.129S20.37 0 13.127 0zm0 .992c6.708 0 12.137 5.427 12.137 12.135s-5.429 12.137-12.137 12.137S.992 19.835.992 13.127A12.127 12.127 0 0113.127.992z"
                color="#000"
            ></path>
        </svg>
    )
}
export const IconSquare = (props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            width="94.802"
            height="94.802"
            version="1.1"
            viewBox="0 0 25.083 25.083"
            // pointerEvents='none'
            // onPointerEnter={() => alert('enter')}

        >
            <g transform="translate(-67.141 -100.463)">
                <path
                    // style={{ InkscapeStroke: "none" }}
                    fill="#000"
                    d="M70.863 100.463c-1.986 0-3.722 1.545-3.722 3.54v18.003c0 1.996 1.736 3.54 3.722 3.54h17.639c1.986 0 3.723-1.544 3.723-3.54v-18.002c0-1.996-1.737-3.541-3.723-3.541zm0 2.627h17.639c.683 0 1.096.443 1.096.914v18.002c0 .47-.413.914-1.096.914H70.863c-.683 0-1.095-.443-1.095-.914v-18.002c0-.471.412-.914 1.095-.914z"
                    color="#000"
                ></path>
            </g>
        </svg>
    )
}
export const IconHeart = (props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            width="415.093"
            height="368.97"
            fill="#000"
            version="1.1"
            viewBox="0 0 12.453 11.069"
        >
            <path
                strokeWidth="0.692"
                d="M6.226 11.07a.692.692 0 01-.302-.07C5.683 10.882 0 8.074 0 3.46a3.46 3.46 0 015.905-2.447l.321.321.322-.321a3.46 3.46 0 015.905 2.446c0 4.598-5.681 7.422-5.924 7.54a.692.692 0 01-.303.07z"
            ></path>
        </svg>
    )
}

export const IconCapsule = (props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 48 28"
            stroke="currentColor"
            strokeWidth="2.2"
        >
            <rect x="3" y="5" width="42" height="18" rx="9" />
        </svg>
    )
}

export const IconMatricula = (props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 56 24"
            stroke="currentColor"
            strokeWidth="2"
        >
            <rect x="3" y="5" width="50" height="14" rx="3" />
            <path d="M13 5v14" />
            <path d="M18 12h27" strokeLinecap="round" />
        </svg>
    )
}

export const IconComicBubble = (props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 48 40"
            stroke="currentColor"
            strokeWidth="2.2"
            strokeLinejoin="round"
        >
            <path d="M6 6 h36 a4 4 0 0 1 4 4 v16 a4 4 0 0 1 -4 4 H20 l-8 8 v-8 H6 a4 4 0 0 1 -4 -4 V10 a4 4 0 0 1 4 -4 Z" />
        </svg>
    )
}

export const IconHousePlate = (props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 48 40"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinejoin="round"
        >
            <rect x="3" y="4" width="42" height="32" rx="4" />
            <path d="M24 10 l9 8 v9 h-18 v-9 Z" />
        </svg>
    )
}

export const IconClapperboard = (props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 48 44"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinejoin="round"
        >
            <path d="M5 15 h38 v24 a3 3 0 0 1 -3 3 H8 a3 3 0 0 1 -3 -3 Z" />
            <path d="M5 15 L42 5 l2 8 -39 10 Z" />
            <path d="M13 13 l7 7 M25 10 l7 7 M37 7 l6 6" />
            <path d="M15 15 l-4 8 M29 15 l-4 8 M42 15 l-4 8" />
        </svg>
    )
}

export const IconOffset = (props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 40 40"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <rect x="6" y="8" width="24" height="24" rx="5" strokeWidth="2" opacity="0.45" />
            <rect x="11" y="13" width="23" height="23" rx="5" strokeWidth="2.4" />
        </svg>
    )
}

export const IconFill = (props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 40 40"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M11 24l9-14 9 14a10 10 0 0 1-18 0z" fill="currentColor" opacity="0.22" strokeWidth="2.2" />
            <path d="M11 24l9-14 9 14a10 10 0 0 1-18 0z" strokeWidth="2.2" />
            <path d="M15 25h10" strokeWidth="2" />
        </svg>
    )
}
// Icono capas para abrir panel de gestión de capas
export function IconLayers() {
    return (
        <div className="flex flex-col items-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-7 h-7">
                <path strokeLinecap="round" strokeLinejoin="round" d="M6.429 9.75 2.25 12l4.179 2.25m0-4.5 5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L21.75 12l-4.179 2.25m0 0 4.179 2.25L12 21.75 2.25 16.5l4.179-2.25m11.142 0-5.571 3-5.571-3" />
            </svg>
        </div>
    );
}

// Icono reloj para abrir panel de historial
export function IconHistory() {
    return (
        <div className="flex flex-col items-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-7 h-7">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
        </div>
    );
}

// History undo: curved arrow counterclockwise ↺
export function IconUndoHistory() {
    return (
        <div className="flex flex-col items-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-7 h-7">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3" />
            </svg>
        </div>
    );
}

// History redo: curved arrow clockwise ↻
export function IconRedoHistory() {
    return (
        <div className="flex flex-col items-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-7 h-7">
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 15l6-6m0 0-6-6m6 6H9a6 6 0 0 0 0 12h3" />
            </svg>
        </div>
    );
}

// Layer: traer al frente (↑ fuera del cuadrado = ir al tope de la pila)
export function IconLayerBringToFront() {
    return (
        <div className="flex flex-col items-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-7 h-7">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15m0-3-3-3m0 0-3 3m3-3V15" />
            </svg>
        </div>
    );
}

// Layer: enviar al fondo (↓ dentro del cuadrado = ir al fondo de la pila)
export function IconLayerSendToBack() {
    return (
        <div className="flex flex-col items-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-7 h-7">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15M12 3v13.5m0 0-3-3m3 3 3-3" />
            </svg>
        </div>
    );
}

// Layer: subir una capa (un paso hacia arriba)
export function IconLayerBringForward() {
    return (
        <div className="flex flex-col items-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-7 h-7">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18" />
            </svg>
        </div>
    );
}

// Layer: bajar una capa (un paso hacia abajo)
export function IconLayerSendBackwards() {
    return (
        <div className="flex flex-col items-center">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-7 h-7">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3" />
            </svg>
        </div>
    );
}

export const IconDogBone = (props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            width="69.373"
            height="41.64"
            version="1.1"
            viewBox="0 0 18.355 11.017"
            xmlSpace="preserve"
        >
            <g transform="translate(-11.863 -91.896)">
                <g
                    fill="none"
                    fillRule="evenodd"
                    transform="matrix(.26458 0 0 .26458 28.138 89.367)"
                >
                    <path d="M24 0v24H0V0zM12.594 23.258l-.012.002-.071.035-.02.004-.014-.004-.071-.036c-.01-.003-.019 0-.024.006l-.004.01-.017.428.005.02.01.013.104.074.015.004.012-.004.104-.074.012-.016.004-.017-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113l-.014.002-.184.093-.01.01-.003.011.018.43.005.012.008.008.201.092c.012.004.023 0 .029-.008l.004-.014-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 00-.027.006l-.006.014-.034.614c0 .012.007.02.017.024l.015-.002.201-.093.01-.008.003-.011.018-.43-.003-.012-.01-.01z"></path>
                    <path
                        fill="#000000"
                        strokeWidth="3.468"
                        d="M7.86 23.414c0 2.526-.676 4.894-1.856 6.937a13.87 13.87 0 11-25.446 10.401H-34.19a13.877 13.877 0 11-25.446-10.401A13.87 13.87 0 11-34.19 19.949l14.747-.004a13.877 13.877 0 0127.302 3.47"
                    ></path>
                </g>
            </g>
        </svg>


    )
}


export const IconHome = (props) => {
    return (
        <svg
            {...props}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5} stroke="currentColor"

        >
            <path strokeLinecap="round" strokeLinejoin="round"
                  d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"/>
        </svg>



    )
}



export const IconGroup = (props) => {
    return (
        <div className="flex flex-col items-center"
             {...props}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                viewBox="0 0 28.64 29.008"
                className="w-10 h-10"
            >
                <path
                    id="seleccion"
                    className=" group-hover:stroke-red-700"
                    fill="black"
                    strokeDasharray="2.376, 0.792"
                    d="M2.797 0l-.135.004-.14.01-.14.015-.077.014.127.781.06-.01.104-.011.103-.008.106-.002h2.377V0H2.805v.352zm3.176 0v.793H8.35V0zM9.14 0v.793h2.377V0zm3.168 0v.793h2.377V0zm3.168 0v.793h2.377V0zm3.168 0v.793h2.376V0zm3.17 0v.793h2.374V0zm3.167 0v.793h.844l.111.002.104.008.104.011.1.016.099.022.095.025.096.03.092.032.09.038.088.04.084.046.082.048.082.055.433-.662-.097-.065-.114-.066-.117-.062-.12-.057L26.913.2l-.127-.045-.129-.04-.133-.036-.134-.027-.137-.024-.139-.015-.14-.01-.14-.004zM1.436.334L1.36.373l-.113.066-.111.073-.106.076L.93.67.832.756.738.848.65.94l-.084.1-.08.102-.074.107-.068.11-.063.113-.056.117-.051.12-.045.124-.04.125-.03.129-.026.13-.017.134-.012.134-.002.09.791.022.002-.069.008-.091.011-.09.018-.09.022-.086.027-.086.03-.084.034-.082.04-.082.042-.078.05-.076.05-.075.055-.07.058-.07.063-.067.066-.064.07-.06.073-.06.076-.054.078-.053.082-.048.059-.03zm26.724.824l-.65.451.05.075.05.076.042.078.04.082.035.082.029.084.027.086.022.086.017.09.012.091c.037.326-.082.77.016 1.305l.779-.142c-.056-.307.051-.73-.008-1.252v-.004l-.017-.127-.026-.131-.031-.129-.04-.125-.044-.123-.05-.121-.058-.117-.064-.114-.068-.109zM0 3.378v2.376h.793V3.379zm27.844 1.087v2.377h.793V4.465zM0 6.547v2.375h.793V6.547zm27.844 1.086v2.377h.793V7.633zM0 9.715v2.375h.793V9.715zM27.844 10.8v2.377h.793V10.8zM0 12.883v2.375h.793v-2.375zm27.844 1.086v2.377h.793v-2.377zM0 16.05v2.375h.793V16.05zm27.844 1.086v2.377h.793v-2.377zM0 19.219v2.375h.793v-2.375zm27.844 1.086v2.377h.793v-2.377zM0 22.387v2.375h.793v-2.375zm27.844 1.086v2.377h.793v-2.377zM0 25.555v.836l.004.13.012.135.017.133.026.13.03.13.04.125.045.123.05.121.057.117.063.113.068.11.074.107.08.102.07.086.604-.514-.058-.07-.055-.07-.05-.075-.05-.076-.043-.078-.039-.082-.035-.082-.03-.084-.026-.086-.022-.086-.018-.09-.011-.09-.008-.091-.002-.1v-.824zm27.832 1.033l-.01.072-.017.09-.022.086-.027.086-.03.084-.035.082-.039.082-.043.078-.048.076-.051.074-.055.07-.059.071-.062.066-.066.065-.07.06-.073.06-.076.054-.078.052-.082.05-.084.042-.088.043-.053.022.305.73.068-.03.121-.056.117-.062.114-.067.111-.072.105-.076.102-.082.098-.086.093-.092.088-.094.084-.1.08-.1.073-.108.068-.11.064-.113.057-.117.05-.121.046-.123.039-.125.031-.13.026-.13.013-.096zM1.756 27.949l-.404.682.01.004.117.062.119.057.125.053.127.045.129.04.132.036.135.027.137.024.138.015.141.01.139.004h1.074v-.793H2.811l-.112-.002-.103-.008-.104-.012-.1-.015-.099-.022-.096-.025-.095-.03-.092-.033-.09-.037-.088-.043zm21.771.295l.3.762c.307.003.588.009.972.001.38-.007.818.028 1.287.012l-.072-.812c-.32.03-.67.015-1.107.009-.524.023-.916.005-1.38.028zm-18.861-.03v.794h2.377v-.793zm3.168 0v.794h2.377v-.793zm3.168 0v.794h2.377v-.793zm3.168 0v.794h2.377v-.793zm3.168 0v.794h2.377v-.793zm3.168 0v.794h2.377v-.793z"
                    opacity="0.79"
                ></path>
                <path
                    style={{  }}
                    fill=""
                    strokeDashoffset="0.443"
                    d="M3.826 1.053c-1.483 0-2.709 1.117-2.709 2.525v2.879c0 1.408 1.226 2.527 2.71 2.527H16.27c1.484 0 2.71-1.12 2.71-2.527V3.578c0-1.408-1.226-2.525-2.71-2.525zm0 .6h12.445c1.186 0 2.11.866 2.11 1.925v2.879c0 1.06-.924 1.928-2.11 1.928H3.826c-1.186 0-2.11-.869-2.11-1.928V3.578c0-1.06.924-1.926 2.11-1.926z"
                    color="#000"
                    opacity="0.79"
                ></path>
                <path
                    style={{  }}
                    fill="none"
                    strokeDashoffset="1.674"
                    d="M21.14 15.229a6.289 6.289 0 00-6.283 6.283 6.287 6.287 0 006.284 6.281 6.285 6.285 0 006.28-6.281 6.287 6.287 0 00-6.28-6.283zm0 .601a5.677 5.677 0 015.682 5.682 5.677 5.677 0 01-5.681 5.681 5.679 5.679 0 01-5.684-5.681 5.679 5.679 0 015.684-5.682z"
                    color="#000"
                    opacity="0.79"
                ></path>
            </svg>
        </div>
    )
}

export const IconUngroup = (props) => {
    return (
        <div className="flex flex-col items-center"
             {...props}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                viewBox="0 0 28.966 29.135"
                className="w-10 h-10"

            >
                <rect
                    width="19.872"
                    height="9.796"
                    x="0.4"
                    y="0.4"
                    fill="none"
                    className="stroke-white group-hover:stroke-red-700"
                    strokeDasharray="2.4, 0.8"
                    strokeDashoffset="0"
                    strokeWidth="0.8"
                    opacity="0.79"
                    rx="1.719"
                    ry="0.773"
                ></rect>
                <rect
                    width="14.304"
                    height="14.008"
                    x="14.252"
                    y="14.718"
                    fill="none"
                    strokeDasharray="2.43489, 0.811631"
                    strokeDashoffset="0"
                    strokeWidth="0.812"
                    className="stroke-white group-hover:stroke-red-700"
                    opacity="0.79"
                    rx="1.238"
                    ry="1.105"
                ></rect>
                <rect
                    width="17.263"
                    height="7.332"
                    x="1.62"
                    y="1.555"
                    fill="none"
                    stroke=""
                    strokeDasharray="none"
                    strokeDashoffset="0.443"
                    strokeWidth="0.6"
                    opacity="0.79"
                    rx="2.409"
                    ry="2.227"
                ></rect>
                <circle
                    cx="21.343"
                    cy="21.714"
                    r="5.982"
                    fill="none"
                    stroke=""
                    strokeDasharray="none"
                    strokeDashoffset="1.674"
                    strokeWidth="0.6"
                    opacity="0.79"
                ></circle>
            </svg>
        </div>
    )
}


export const IconOrca = (props) => {
    return (
        <div className="flex flex-col items-center"
             {...props}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 64 64"

            >
                <rect width="64" height="64" fill="#e9e9e9" rx="14"></rect>
                <path
                    fill="#292826"
                    d="M13.84 50.354a19.7 19.7 0 0013.883 5.79 19.944 19.944 0 0014.135-33.962z"
                ></path>
                <path
                    fill="#009789"
                    d="M41.858 22.181L13.84 50.354l.061.059a220.548 220.548 0 0032.477-21.136 19.964 19.964 0 00-4.52-7.1"
                ></path>
                <path
                    fill="#292826"
                    d="M36.381 7.856a19.943 19.943 0 00-14.054 33.962l28.018-28.172a19.693 19.693 0 00-13.964-5.79"
                ></path>
                <path
                    fill="#262523"
                    d="M36.381 7.856a19.636 19.636 0 00-10.341 2.926 22.742 22.742 0 00-5.91-.745 23.084 23.084 0 00-9.477 2.124.632.632 0 00.129 1.191 13.52 13.52 0 018.069 5.137 20.06 20.06 0 00-1.441 15.045 19.873 19.873 0 012-3.488c1.819-2.5 3.743-3.8 6.585-5.723 2.093-1.416 5-3.077 13.359-6.512a28.421 28.421 0 006.12-2.821c1.4-.831 2.461-1.615 2.8-2.842a6.87 6.87 0 00.065-.256 19.655 19.655 0 00-11.958-4.036"
                ></path>
                <path
                    fill="#fff"
                    d="M39.69 14.551c.727 1.285-.728 3.495-3.249 4.937s-5.154 1.569-5.88.284.727-3.495 3.248-4.937 5.154-1.569 5.881-.284"
                ></path>
            </svg>
        </div>
    )
}



export function IconEdit(props){
    return (
        <div className="flex flex-col items-center"
             {...props}
        >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10" />
            </svg>
        </div>
    )
}

export function IconUsers(props){
    return (
        <div className="flex flex-col items-center"
             {...props}
        >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" >
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
            </svg>

        </div>
    )
}
export function IconUser(props){
    return (
        <div className="flex flex-col items-center"
             {...props}
        >

            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" >
                <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
            </svg>

        </div>
    )
}
export function IconProject(props){
    return (
        <div className="flex flex-col items-center"
             {...props}
        >

            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                viewBox="0 0 26.418 21.564"
            >
                <path
                    fill="#fff"
                    d="M1.524 20.96C-.049 19.9-.05 19.89.024 10.39l.068-8.66.865-.865C1.706.115 2 0 3.16 0 4.34 0 4.594.104 5.273.864c.425.475.772 1.04.772 1.257 0 .34 1.356.393 10.186.393h10.187v19.05H2.419zM25.36 12.04V3.572H6.31v7.408c0 7.232-.013 7.409-.53 7.409-.3 0-.529-.177-.529-.41 0-.712-1.233-1.707-2.116-1.707-1.85 0-2.78 2.271-1.468 3.584l.65.65H25.36zM8.955 16.272c0-.515.177-.53 6.615-.53 6.438 0 6.615.015 6.615.53s-.177.529-6.615.529c-6.438 0-6.615-.014-6.615-.53zm.972-3.813c-.09-.234.52-.955 1.625-1.921 2.946-2.577 2.523-2.488 4.163-.868l1.442 1.424L18.48 9.79c.728-.717 1.323-1.42 1.323-1.56 0-.143-.259-.534-.575-.87l-.575-.613h3.532v3.532l-.613-.576c-.337-.316-.72-.575-.853-.575-.132 0-.987.74-1.9 1.645l-1.66 1.646-1.45-1.432-1.45-1.433-.601.525c-.331.289-1.164 1.027-1.852 1.64-1.347 1.199-1.656 1.32-1.879.74zm-6.792 2.758c.363 0 .988.17 1.389.38l.727.379V2.225l-.65-.65c-.858-.859-2.074-.859-2.934 0l-.65.65V15.976l.729-.38c.4-.208 1.025-.38 1.389-.38z"
                ></path>
            </svg>

        </div>
    )
}
export function IconPresupuesto(props){
    return (
        <div className="flex flex-col items-center"
             {...props}
        >

            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" >
                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m3.75 9v7.5m2.25-6.466a9.016 9.016 0 0 0-3.461-.203c-.536.072-.974.478-1.021 1.017a4.559 4.559 0 0 0-.018.402c0 .464.336.844.775.994l2.95 1.012c.44.15.775.53.775.994 0 .136-.006.27-.018.402-.047.539-.485.945-1.021 1.017a9.077 9.077 0 0 1-3.461-.203M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" />
            </svg>


        </div>
    )
}
export function IconPhoto(props){
    return (
        <div className="flex flex-col items-center"
        >

            <svg
                {...props}

                xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" >
                <path strokeLinecap="round" strokeLinejoin="round" d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
            </svg>



        </div>
    )
}
export function IconInstagram(props){
    return (
        <div className="flex flex-col items-center"
        >

            <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlSpace="preserve"
                id="Layer_1"
                fill="#000"
                version="1.1"
                viewBox="0 0 169.063 169.063"
                {...props}
            >
                <g id="SVGRepo_iconCarrier">
                    <path d="M122.406 0H46.654C20.929 0 0 20.93 0 46.655v75.752c0 25.726 20.929 46.655 46.654 46.655h75.752c25.727 0 46.656-20.93 46.656-46.655V46.655C169.063 20.93 148.133 0 122.406 0m31.657 122.407c0 17.455-14.201 31.655-31.656 31.655H46.654C29.2 154.063 15 139.862 15 122.407V46.655C15 29.201 29.2 15 46.654 15h75.752c17.455 0 31.656 14.201 31.656 31.655z"></path>
                    <path d="M84.531 40.97c-24.021 0-43.563 19.542-43.563 43.563 0 24.02 19.542 43.561 43.563 43.561s43.563-19.541 43.563-43.561c0-24.021-19.542-43.563-43.563-43.563m0 72.123c-15.749 0-28.563-12.812-28.563-28.561s12.813-28.563 28.563-28.563 28.563 12.813 28.563 28.563-12.814 28.561-28.563 28.561M129.921 28.251c-2.89 0-5.729 1.17-7.77 3.22a11.05 11.05 0 0 0-3.23 7.78c0 2.891 1.18 5.73 3.23 7.78 2.04 2.04 4.88 3.22 7.77 3.22 2.9 0 5.73-1.18 7.78-3.22 2.05-2.05 3.22-4.89 3.22-7.78 0-2.9-1.17-5.74-3.22-7.78-2.04-2.05-4.88-3.22-7.78-3.22"></path>
                </g>
            </svg>



        </div>
    )
}
export function IconFacebook(props){
    return (
        <div className="flex flex-col items-center"
        >

            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
                <path
                    id="SVGRepo_iconCarrier"
                    fill="#0F0F0F"
                    fillRule="evenodd"
                    d="M20 1a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3zm0 2a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1h-5v-7h2.076a1 1 0 0 0 .949-.684l.443-1.329a.75.75 0 0 0-.712-.987H15V9c0-.5.5-1 1-1h2a1 1 0 0 0 1-1v-.686a.71.71 0 0 0-.519-.695C17.171 5.273 16 5.273 16 5.273c-2.5 0-4 1.727-4 3.227V11h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2v7H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"
                    clipRule="evenodd"
                ></path>
            </svg>


        </div>
    )
}
export function IconTwitter(props){
    return (
        <div className="flex flex-col items-center"
        >

            <svg
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="xMidYMid"
                viewBox="0 0 31.812 26"
                {...props}
            >
                <path
                    id="SVGRepo_iconCarrier"
                    d="M20.877 2c1.642 0 3.505.652 4.549 1.738a11.6 11.6 0 0 0 3.624-1.352 5.62 5.62 0 0 1-2.51 3.083 11.7 11.7 0 0 0 3.28-.879 11.5 11.5 0 0 1-2.849 2.887q.016.357.016.718C26.987 15.562 21.445 24 10.939 24c-3.224 0-6.432-.867-8.957-2.449q.67.08 1.361.08c2.676 0 5.139-.891 7.096-2.389-2.502-.043-4.612-1.656-5.336-3.869q.522.098 1.075.1c.518 0 1.025-.067 1.503-.196C5.068 14.768 3.1 12.514 3.1 9.813V9.74c.771.418 1.65.67 2.587.7-1.533-1.003-2.54-2.706-2.54-4.641 0-1.022.281-1.981.772-2.801 2.816 3.369 7.026 5.59 11.774 5.824a5.4 5.4 0 0 1-.15-1.269c0-3.08 2.178-5.553 5.334-5.553m8.943 2.59h.005M20.877 0c-3.844 0-6.817 2.753-7.263 6.552-3.189-.647-6.09-2.348-8.174-4.841a1.982 1.982 0 0 0-3.224.255A7.47 7.47 0 0 0 1.625 8.4a2 2 0 0 0-.512 1.34v.073c0 1.959.769 3.776 2.047 5.139-.073.342-.057.703.055 1.046a7.54 7.54 0 0 0 2.284 3.398 9.9 9.9 0 0 1-3.277.169 1.988 1.988 0 0 0-2.114 1.321c-.31.884.032 1.867.824 2.363C3.764 25.023 7.318 26 10.939 26c6.839 0 11.086-3.157 13.444-5.805 2.86-3.211 4.524-7.477 4.589-11.74a13.5 13.5 0 0 0 2.438-2.663c.251-.334.4-.751.4-1.202 0-.681-.337-1.282-.852-1.644a2.01 2.01 0 0 0-.655-2.113 1.98 1.98 0 0 0-2.247-.179 9.5 9.5 0 0 1-2.125.908C24.555.592 22.688 0 20.877 0"
                ></path>
            </svg>



        </div>
    )
}
export function IconGotaAgua(props){
    return (
        <div className="flex flex-col items-center"
        >

            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="h-5 w-5"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M12 3.75c3 3.75 8.25 9.3 8.25 13.25A8.25 8.25 0 1112 3.75z"
                />
            </svg>



        </div>
    )
}
